
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Switcher',
})
export default class Switcher extends Vue {
  setLocale(locale: string) {
    this.$i18n.locale = locale
    localStorage.setItem('lang', this.$i18n.locale);
    let url = new URL(window.location.href);
    url.searchParams.set('lg', locale);
    window.location.href = url.toString();
  }
  getFlag(locale: string) {
    return locale.split('-')[0] || 'sl'
  }
}
